// extracted by mini-css-extract-plugin
module.exports = {"group":"a10a3f92e9--group--YAlwp"};